// extracted by mini-css-extract-plugin
export var container = "tool-tip-badge-module--container--fDPD+";
export var description = "tool-tip-badge-module--description--rJWRx";
export var medal = "tool-tip-badge-module--medal--3nYFD";
export var quickTip = "tool-tip-badge-module--quick-tip--fx6NL";
export var root = "tool-tip-badge-module--root--Wp9aV";
export var title = "tool-tip-badge-module--title--Pri-+";